import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home';
import Login from '../views/Login';
import Step1Reason from '../views/Step1Reason';
import Step2Contact from '../views/Step2Contact';
import Step3Household from '../views/Step3Household';
import Step4Capital from '../views/Step4Capital';
import Step5Car from '../views/Step5Car';
import Step6Income from '../views/Step6Income';
import Step7Expense from '../views/Step7Expense';
import Step8Attachment from '../views/Step8Attachment';
import Step9Signature from '../views/Step9Signature';
import Finish from '../views/Finish';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/login/:token',
        name: 'login',
        component: Login,
    },
    {
        path: '/step1',
        name: 'step1_reason',
        component: Step1Reason,
    },
    {
        path: '/step2',
        name: 'step2_contact',
        component: Step2Contact,
    },
    {
        path: '/step3',
        name: 'step3_household',
        component: Step3Household,
    },
    {
        path: '/step4',
        name: 'step4_capital',
        component: Step4Capital,
    },
    {
        path: '/step5',
        name: 'step5_car',
        component: Step5Car,
    },
    {
        path: '/step6',
        name: 'step6_income',
        component: Step6Income,
    },
    {
        path: '/step7',
        name: 'step7_expense',
        component: Step7Expense,
    },
    {
        path: '/step8',
        name: 'step8_attachment',
        component: Step8Attachment,
    },
    {
        path: '/step9',
        name: 'step9_signature',
        component: Step9Signature,
    },
    {
        path: '/finish',
        name: 'finish',
        component: Finish,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    let redirect = null;

    const loggedIn = false;
    if (to.matched.some(route => route.meta.requiresAuth) && !loggedIn) {
        console.log('Unauthorized route access, redirecting...');
        redirect = { name: 'home' };
    }

    if (redirect === null) {
        next();
    } else {
        next(redirect);
    }
});

export default router;
